import OrgType from '@/constants/orgType.constant';
import { CampaignType } from '@/constants/postType.constants';
import { hasAppAccess } from '@/stores/userActions';
import { AppPreferenceItem } from '@/utils/appPreference';
import { getUserCountry } from '@/utils/user.helper';

export const TEMPLATES = [
  {
    createdAt: '2022-08-01T04:10:33.989Z',
    created_by: 1,
    default_message: 'Raise funds for a Nonprofit!',
    description: 'For a Nonprofit',
    id: 1,
    name: 'For a Nonprofit',
    post_bg_resource_type: 'image',
    post_bg_resource_url: '/assets/images/celebrate-2.png',
    updatedAt: '2022-08-01T04:10:33.989Z',
    appName: AppPreferenceItem.FundRaise,
  },
  {
    createdAt: '2022-08-01T04:10:33.989Z',
    created_by: 1,
    default_message: 'Raise funds for an individual in need!',
    description: 'For an individual in need',
    id: 2,
    name: 'For an individual in need',
    post_bg_resource_type: 'image',
    post_bg_resource_url: '/assets/images/celebrate-3.png',
    updatedAt: '2022-08-01T04:10:33.989Z',
    appName: AppPreferenceItem.CrowdFunding,
  },
  {
    createdAt: '2022-08-01T04:10:33.989Z',
    created_by: 1,
    default_message: 'Fundraise for your organization!',
    description: 'For your Organization',
    id: 3,
    name: 'For your Organization',
    post_bg_resource_type: 'image',
    post_bg_resource_url: '/assets/images/celebrate-3.png',
    updatedAt: '2022-08-01T04:10:33.989Z',
    appName: AppPreferenceItem.CrowdFunding,
  },
  {
    createdAt: '2022-08-01T04:10:33.989Z',
    created_by: 1,
    default_message: 'Campaign to collect goods or supplies!',
    description: 'In-Kind',
    id: 4,
    name: 'In-Kind',
    post_bg_resource_type: 'image',
    post_bg_resource_url: '/assets/images/celebrate-1.png',
    updatedAt: '2022-08-01T04:10:33.989Z',
    appName: AppPreferenceItem.InKindDonation,
  },
  {
    createdAt: '2022-08-01T04:10:33.989Z',
    created_by: 1,
    default_message: 'Launch a campaign & share with friends!',
    description: 'Peer-To-Peer',
    id: 5,
    name: 'Peer-To-Peer',
    post_bg_resource_type: 'image',
    post_bg_resource_url: '/assets/images/celebrate-3.png',
    updatedAt: '2022-08-01T04:10:33.989Z',
    appName: AppPreferenceItem.P2PFundRaise,
  },
];

export const CROWDFUNDS = [
  {
    id: 2,
    type: 'individual',
  },
  {
    id: 3,
    type: 'organization',
  },
];

export const FUNDRAISERS = [
  {
    id: 1,
    type: CampaignType.FundRaise,
  },
  ...CROWDFUNDS,
  {
    id: 4,
    type: CampaignType.CollectGoods,
  },
  {
    id: 5,
    type: CampaignType.P2PFundRaise,
  },
];

export function getFundRaiseTemplates(user) {
  const userCountry = getUserCountry(user);
  const processedTemplates = TEMPLATES.map((template) => {
    const updatedTemplate = { ...template };

    if (userCountry === 'IN') {
      updatedTemplate.default_message = updatedTemplate.default_message.replace(
        /a Nonprofit/g,
        'an NGO',
      );
      updatedTemplate.description = updatedTemplate.description.replace(
        /a Nonprofit/g,
        'an NGO',
      );
      updatedTemplate.name = updatedTemplate.name.replace(/a Nonprofit/g, 'an NGO');
    }

    if (user?.activeCommunity?.orgType === OrgType.NonProfit) {
      updatedTemplate.default_message = updatedTemplate.default_message
        .replace(/ a /g, ' your ')
        .replace(/ an /g, ' your ');
      updatedTemplate.description = updatedTemplate.description
        .replace(/ a /g, ' your ')
        .replace(/ an /g, ' your ');
      updatedTemplate.name = updatedTemplate.name
        .replace(/ a /g, ' your ')
        .replace(/ an /g, ' your ');
    }

    return updatedTemplate;
  });

  return processedTemplates.filter((template) =>
    hasAppAccess(template.appName),
  );
}
